import React from 'react';

import Button from 'material-ui/FloatingActionButton';

export default ({ children, ...props }) => <Button {...props}>{children}</Button>;



// WEBPACK FOOTER //
// ./src/components/basic/FloatingActionButton.js